/**
 * What a `back_restore` event can say, shared by the browser that sends it
 * (utils/back-restore-report.ts), the schema that admits it
 * (schemas/tracking-events.ts) and the cron that reads it
 * (utils/clickhouse/back-restore-health.ts). No imports, so the server side
 * does not pull in the browser's analytics client.
 */

export const BACK_RESTORE_EVENT = 'back_restore';

export const BACK_KINDS = ['home', 'browse', 'foryou', 'search', 'other'] as const;
export type BackKind = (typeof BACK_KINDS)[number];

export const BACK_OUTCOMES = ['restored', 'gave_up'] as const;
export type BackOutcome = (typeof BACK_OUTCOMES)[number];

export const BACK_DEVICES = ['phone', 'tablet', 'desktop'] as const;
export type BackDevice = (typeof BACK_DEVICES)[number];

/**
 * What the scroll restore was still waiting for on its last check before it
 * scrolled or gave up: `none` when the page was ready at the first look,
 * `listings` for no tiles yet, `height` for a page still too short to scroll
 * to where they were. `count` (fewer tiles than the reader had loaded) is only
 * on rows from before 2026-10-28, when Back stopped waiting on a tile count.
 */
export const BACK_WAITS = ['none', 'listings', 'count', 'height'] as const;
export type BackWait = (typeof BACK_WAITS)[number];

export function backKind(pathname: string): BackKind {
  if (pathname === '/') return 'home';
  if (pathname.startsWith('/browse')) return 'browse';
  if (pathname.startsWith('/foryou')) return 'foryou';
  if (pathname.startsWith('/search') || pathname.startsWith('/s/')) return 'search';
  return 'other';
}

export function deviceClass(width: number): BackDevice {
  if (width < 768) return 'phone';
  if (width < 1024) return 'tablet';
  return 'desktop';
}
